import {
	createAsyncThunk,
	createSelector,
	createSlice,
} from '@reduxjs/toolkit';
import { getSceneObjects } from '@wsc/apis/webStoreAPI';

const roomObjectsSlice = createSlice({
	name: 'room_objects',
	initialState: {},
	reducers: {
		setRoomObjects: (state, action) => {
			const indexed = action.payload.reduce(
				(acc, curr) => ({ ...acc, [curr._id.$oid]: curr }),
				{},
			);
			return { ...indexed };
		},
		setRoomObjectById: (state, action) => {
			const { id, ...rest } = action.payload;
			state[id] = { ...state[id], ...rest };
		},
		deleteById: (state, action) => {
			const { id } = action.payload;
			delete state[id];
		},
		clearRoomObjects: (state) => (state = {}),
	},
	extraReducers: (builder) => {
		builder.addCase(
			fetchRoomObjectsBySceneId.fulfilled,
			(state, action) => {
				const indexed = action.payload.reduce(
					(acc, curr) => ({ ...acc, [curr._id.$oid]: curr }),
					{},
				);
				return { ...indexed };
			},
		);
	},
});

export const fetchRoomObjectsBySceneId = createAsyncThunk(
	'room_objects/fetchRoomObjectsById',
	async ({ sceneId, locale }) => {
		return await getSceneObjects(sceneId, locale);
	},
);

export const {
	setRoomObjects,
	clearRoomObjects,
	setRoomObjectById,
	deleteById,
} = roomObjectsSlice.actions;

export const createRoomObjectDataSelector = (lookupId) =>
	createSelector([(state) => state.roomObjects], (roomObjects) => {
		return roomObjects[lookupId];
	});

/*
 * @description
 * Selects all room objects that have a selector value of text_object.
 *
 * @returns {Array} - All room objects with a selector value of text_object.
 */
export const selectInSceneTextRoomObjects = createSelector(
	[(state) => Object.values(state.roomObjects)],
	(roomObjects) =>
		roomObjects.filter((item) => item?.props?.selector === 'text_object'),
);

export default roomObjectsSlice.reducer;
